import React, { useState, useContext } from 'react';
import { Box, TextField, Button, Modal, Menu, MenuItem, Grid, Typography } from '@mui/material';
import axios from "axios";
import { UserContext } from "./UserContext";

const replyModalFill = '#353739';
const replyModalColor = '#7F7F7F';

const ReplyModal = ({ email, handleClose }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    // Zustand für das Nachrichten-Textfeld
    const [messageContent, setMessageContent] = useState('');

    const userContext = useContext(UserContext);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handlePositiveResponse = async () => {
        try {
            const response = await axios.post('https://boring-ride.95-216-35-79.plesk.page:5000/generate_reply', {
                email_content: email.content
            });

            if (response.status === 200) {
                const positiveResponse = response.data.positive_response;
                console.log('Positive response:', positiveResponse);

                // Setzen Sie die generierte positive Antwort als Inhalt des Nachrichten-Textfeldes
                setMessageContent(positiveResponse);
            } else {
                console.error(`Failed to generate positive response: ${response.status}`);
            }
        } catch (error) {
            console.error(`Failed to generate positive response: ${error}`);
        }

        setAnchorEl(null);
    };

    const handleNegativeResponse = async () => {
        try {
            const response = await axios.post('https://boring-ride.95-216-35-79.plesk.page:5000/generate_reply', {
                email_content: email.content
            });

            if (response.status === 200) {
                const negativeResponse = response.data.negative_response;
                console.log('Negative response:', negativeResponse);
                // Hier können Sie den erhaltenen negativen Antworttext verwenden
                // Setzen Sie die generierte positive Antwort als Inhalt des Nachrichten-Textfeldes
                setMessageContent(negativeResponse);
            } else {
                console.error(`Failed to generate negative response: ${response.status}`);
            }
        } catch (error) {
            console.error(`Failed to generate negative response: ${error}`);
        }

        setAnchorEl(null);
    };

    const handleSend = async () => {
        const emailData = {
            email_address: userContext.email,
            password: userContext.password,
            recipients_to: [email.sender],
            recipients_cc: [],
            recipients_bcc: [],
            subject: `RE: ${email.subject}`,
            content: messageContent
        };

        try {
            const response = await axios.post('https://boring-ride.95-216-35-79.plesk.page:5000/send_email', emailData);
            if (response.status === 200) {
                alert('Die E-Mail wurde erfolgreich versendet.');
            } else {
                alert('Beim Senden der E-Mail ist ein Fehler aufgetreten.');
            }
        } catch (error) {
            console.error("Es gab einen Fehler beim Senden der E-Mail: ", error);
        }

        handleClose();
    }

    if (!email) return null;

    return (
        <Modal open={true} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    width: 800,
                    backgroundColor: 'white',
                    border: '2px solid #000',
                    boxShadow: 24,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 2
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={6} sx={{ bgcolor: '#262626', p: 3 }}>
                        <TextField
                            fullWidth
                            label="An"
                            value={email.sender}
                            variant="outlined"
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <TextField
                            fullWidth
                            label="Empfänger (CC)"
                            variant="outlined"
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <TextField
                            fullWidth
                            label="Empfänger (BCC)"
                            variant="outlined"
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <TextField
                            fullWidth
                            label="Betreff"
                            defaultValue={`RE: ${email.subject}`}
                            variant="outlined"
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                    </Grid>
                    <Grid item xs={6} sx={{ bgcolor: '#1F1F1F', borderLeft: '1px solid rgba(127,127,127,0.2)', p: 3 }}>
                        <TextField
                            fullWidth
                            label="Nachricht"
                            multiline
                            rows={14}
                            variant="outlined"
                            value={messageContent}  // Setzen Sie den Inhalt des Textfeldes auf den Wert des Zustands
                            onChange={(event) => setMessageContent(event.target.value)}  // Aktualisieren Sie den Zustand, wenn das Textfeld geändert wird
                            sx={{ mb: 2, ...textFieldStyle }}
                        />
                        <Button variant="contained" color="secondary" onClick={handleClick} sx={{ mb: 2, bgcolor: '#006AD4', boxShadow: 'none', mr: 2 }}>
                            Antwort Ki generieren lassen
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem onClick={handlePositiveResponse}>Positiv antworten</MenuItem>
                            <MenuItem onClick={handleNegativeResponse}>Negativ antworten</MenuItem>
                        </Menu>
                        <Button variant="contained" disableElevation sx={{bgcolor: '#006AD4', boxShadow: 'none', mr: 2 }} onClick={handleSend}>
                            Senden
                        </Button>
                        <Button variant="outlined" onClick={handleClose}>
                            Verwerfen
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
}

// Style for the text fields, to avoid repetition
const textFieldStyle = {
    '.MuiOutlinedInput-root': {
        bgcolor: replyModalFill,
        color: replyModalColor,
        '& fieldset': {
            borderColor: replyModalColor,
        },
        '&:hover fieldset': {
            borderColor: replyModalColor,
        },
        '&.Mui-focused fieldset': {
            borderColor: replyModalColor,
        },
        '& input': {  // Changing the color of the text to white when typing
            color: 'white',
        },
        '& textarea': {  // Changing the color of the text to white when typing
            color: 'white',
        },
    },
    '.MuiInputLabel-root': {
        color: replyModalColor,
    },
};

export default ReplyModal;
